////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const initKioskCreationAddPrices = {
	postKioskAddPrices: (filters = {}, requestId, queryParams = { page: '0', size: '250' }) => ({
		type: ActionsTypes.POST_KIOSK_ADD_PRICES,
		payload: {
			filters,
			requestId,
			queryParams,
		},
	}),
	postKioskAddPricesSuccess: (data, id) => ({
		type: ActionsTypes.POST_KIOSK_ADD_PRICES_SUCCESS,
		payload: {
			data,
			id,
		},
	}),
	postKioskAddPricesFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_ADD_PRICES_FAILURE,
		payload: {
			error,
		},
	}),
	putUpdatePrices: (newPrice = {}, requestId, action) => ({
		type: ActionsTypes.PUT_UPDATE_PRICES,
		payload: {
			newPrice,
			requestId,
			action,
		},
	}),
	putUpdatePricesSuccess: (data) => ({
		type: ActionsTypes.PUT_UPDATE_PRICES_SUCCESS,
		payload: {
			data,
		},
	}),
	putUpdatePricesFailure: (error) => ({
		type: ActionsTypes.PUT_UPDATE_PRICES_FAILURE,
		payload: {
			error,
		},
	}),
	putValidatePrices: (requestId, redirectTest) => ({
		type: ActionsTypes.PUT_VALIDATE_PRICES,
		payload: {
			requestId,
			redirectTest,
		},
	}),
	putValidatePricesSuccess: (data) => ({
		type: ActionsTypes.PUT_VALIDATE_PRICES_SUCCESS,
		payload: {
			data,
		},
	}),
	putValidatePricesFailure: (error) => ({
		type: ActionsTypes.PUT_VALIDATE_PRICES_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataAddPrices: () => ({
		type: ActionsTypes.RESET_DATA_ADD_PRICES,
	}),
}

export default initKioskCreationAddPrices
